<template lang="pug">
.container-perfil-publico
  .header-publico
    .header-content
      .logo-section
        img.logo(src="@/assets/logo.webp" alt="Nexa Skills" @click="$router.push('/')")
      .acoes(v-if="!isAuthenticated")
        ButtonPadrao.btn-login(variant="negative" @click="$router.push('/login')") Entrar
        ButtonPadrao(@click="$router.push('/cadastrar')") Cadastrar
      el-popover(
        v-else
        placement="bottom-end"
        width="280"
        trigger="click"
        popper-class="user-popover"
      )
        .user-popover-content
          .user-info
            .user-name {{ getUser.nome || 'Usuário' }}
            .user-email {{ getUser.email || '' }}
          .popover-actions
            ButtonPadrao(@click="voltarMeuPerfil") Voltar para meu perfil
        template(#reference)
          .user-avatar-container
            img.user-avatar(:src="getFotoUsuarioLogado" alt="Perfil")
  
  .loading(v-if="carregando")
    .spinner
    p Carregando perfil...
  
  .erro(v-else-if="erro")
    LucideIcon(name="AlertCircle" :size="48" color="#f87171")
    p {{ mensagemErro }}
    ButtonPadrao(@click="$router.push('/')") Voltar para Home
  
  .conteudo(v-else)
    .busca-usuario
      .busca-container
        .busca-label
          LucideIcon(name="Search" :size="16")
          span Buscar perfil de usuário
        .busca-input-group
          input.input-busca(
            v-model="usernameBusca"
            type="text"
            placeholder="Digite o @ do usuário (ex: usuario123)"
            @keyup.enter="buscarUsuario"
          )
          ButtonPadrao(@click="buscarUsuario" :disabled="!usernameBusca || usernameBusca.trim() === ''")
            LucideIcon(slot="icon-left" name="Search" :size="16")
            | Buscar
    
    .container-perfil
      .header
        .info-desenvolvedor
          .pessoa
            .foto-perfil
              img(:src="fotoPerfil" alt="Foto do Desenvolvedor")
            .info
              .nome
                span {{ nomeUsuario }}
              .usuario
                LucideIcon(name="AtSign" :size="16")
                span.usuario-text {{ usuarioApelido }}
                .copiar-usuario(@click="copiarUsuario" title="Copiar usuário")
                  LucideIcon(name="Copy" :size="16")
              .funcao(v-if="funcaoUsuario")
                LucideIcon(name="Briefcase" :size="16")
                | {{ funcaoUsuario }}
              .localizacao(v-if="localizacaoUsuario")
                LucideIcon(name="MapPin" :size="16")
                | {{ localizacaoUsuario }}
          .descricao(v-if="biografiaUsuario") {{ biografiaUsuario }}
        .card-podium
          .top-3(
            v-for="(podium, idx) in podiumHabilidades"
            :key="podium.skill"
            v-if="podiumHabilidades.length > 0"
          )
            .trofeu
              LucideIcon(name="Trophy" :size="16" :color="podium.filledColor")
            Estrelas(
              :filled="podium.filled"
              :filledColor="podium.filledColor"
              :size="estrelasSize"
              useStroke
            )
            .habilidade {{ podium.skill }}
            .posicao {{ podium.posicao }}º Lugar
          .mensagem-vazia(v-if="podiumHabilidades.length === 0")
            LucideIcon(name="Trophy" :size="32" color="#4b5563")
            p Nenhuma habilidade top 3 cadastrada
      .habilidades
        .label-habilidades
          LucideIcon(name="Star" :size="16" color="#b7ff00")
          | Habilidades
        template(v-if="habilidades.length > 0")
          BarraHabilidades(
            v-for="(hab, idx) in habilidades"
            :key="hab.skill"
            :skill="hab.skill"
            :level="hab.level"
          )
        .mensagem-vazia(v-else)
          LucideIcon(name="Star" :size="32" color="#4b5563")
          p Nenhuma habilidade cadastrada
      .btn-acoes-social
        .btn-social-group(v-if="hasAnySocialLink")
          .btn-social(v-if="githubLink")
            ButtonPadrao(variant="negative" iconOnly @click="openLink(githubLink)")
              LucideIcon(slot="icon-left" name="Github" :size="16")
          .btn-social(v-if="linkedinLink")
            ButtonPadrao(variant="negative" iconOnly @click="openLink(linkedinLink)")
              LucideIcon(slot="icon-left" name="Linkedin" :size="16")
          .btn-social(v-if="emailUsuario")
            ButtonPadrao(variant="negative" iconOnly @click="openLink(`mailto:${emailUsuario}`)")
              LucideIcon(slot="icon-left" name="Mail" :size="16")
        .btn-contato-wrapper
          ButtonPadrao(variant="default" disabled) Contato
          .tooltip-contato Em construção
</template>

<script>
import { mapGetters } from 'vuex'
import BarraHabilidades from '@/components/ui/BarraHabilidades.vue'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'
import Estrelas from '@/components/ui/Stars.vue'
import LucideIcon from '@/components/LucideIcon.vue'
import ApiService from '@/services/api.js'
import MessageMixin from '@/mixins/MessageMixin'

export default {
  name: 'PerfilPublico',
  mixins: [MessageMixin],
  components: {
    BarraHabilidades,
    ButtonPadrao,
    Estrelas,
    LucideIcon
  },
  data() {
    return {
      fotoPerfil: require('@/assets/placeholder.svg'),
      windowWidth: typeof window !== 'undefined' ? window.innerWidth : 0,
      carregando: true,
      erro: false,
      mensagemErro: '',
      perfilData: null,
      usernameBusca: ''
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'getUser']),
    
    username() {
      return this.$route.params.username
    },

    getFotoUsuarioLogado() {
      if (!this.getUser || !this.getUser.foto_perfil) {
        return require('@/assets/placeholder.svg')
      }
      
      // Garante que a foto tem o prefixo data URI correto
      const foto = this.getUser.foto_perfil
      if (foto.startsWith('data:image')) {
        return foto
      } else {
        // Adiciona o prefixo data URI se não tiver
        return `data:image/jpeg;base64,${foto}`
      }
    },

    podiumHabilidades() {
      if (!this.perfilData || !this.perfilData.top_habilidades) return []
      
      return this.perfilData.top_habilidades
        .filter(item => item.name && item.name.trim() !== '')
        .map((item) => ({
          skill: item.name,
          posicao: item.posicao || 1,
          filled: this.getNivelStars(item.nivel),
          filledColor: item.cor_hex || '#facc15'
        }))
    },
    
    habilidades() {
      if (!this.perfilData || !this.perfilData.classes) return []
      
      const todasHabilidades = []
      this.perfilData.classes.forEach(classe => {
        if (classe.skills && Array.isArray(classe.skills)) {
          classe.skills.forEach(skill => {
            todasHabilidades.push({
              skill: skill.name,
              level: skill.nivel || 'Iniciando'
            })
          })
        }
      })
      
      // Define a ordem dos níveis (do maior para o menor)
      const ordemNiveis = {
        'Mestre': 6,
        'Professor': 5,
        'Profissional': 4,
        'Praticante': 3,
        'Aprendiz': 2,
        'Iniciando': 1
      }
      
      // Ordena as habilidades por nível
      return todasHabilidades.sort((a, b) => {
        const nivelA = ordemNiveis[a.level] || 0
        const nivelB = ordemNiveis[b.level] || 0
        return nivelB - nivelA
      })
    },
    
    estrelasSize() {
      return this.windowWidth <= 390 ? 14 : 16
    },
    
    nomeUsuario() {
      if (!this.perfilData) return 'Carregando...'
      return (this.perfilData.nome && this.perfilData.nome.trim() !== '') 
        ? this.perfilData.nome 
        : 'Nome do Desenvolvedor'
    },
    
    usuarioApelido() {
      if (!this.perfilData) return '@carregando'
      return this.perfilData.usuario || this.perfilData.email || 'usuario'
    },
    
    funcaoUsuario() {
      if (!this.perfilData) return ''
      return this.perfilData.funcao || ''
    },
    
    localizacaoUsuario() {
      if (!this.perfilData) return ''
      
      const partes = []
      if (this.perfilData.cidade) partes.push(this.perfilData.cidade)
      if (this.perfilData.uf) partes.push(this.perfilData.uf)
      
      return partes.join(', ')
    },
    
    biografiaUsuario() {
      if (!this.perfilData) return ''
      return this.perfilData.biografia || ''
    },
    
    emailUsuario() {
      if (!this.perfilData) return ''
      return this.perfilData.email || ''
    },
    
    githubLink() {
      if (!this.perfilData || !this.perfilData.git) return ''
      return this.perfilData.git
    },
    
    linkedinLink() {
      if (!this.perfilData || !this.perfilData.linkedin) return ''
      return this.perfilData.linkedin
    },
    
    hasAnySocialLink() {
      return !!(this.githubLink || this.linkedinLink || this.emailUsuario)
    },
    
    fotoPerfilUsuario() {
      if (!this.perfilData || !this.perfilData.foto_perfil) {
        return require('@/assets/placeholder.svg')
      }
      
      const foto = this.perfilData.foto_perfil
      if (foto.startsWith('data:image')) {
        return foto
      } else {
        return `data:image/jpeg;base64,${foto}`
      }
    }
  },
  watch: {
    fotoPerfilUsuario: {
      handler(newFoto) {
        this.fotoPerfil = newFoto
      },
      immediate: true
    },
    username: {
      handler() {
        this.carregarPerfil()
      },
      immediate: true
    }
  },
  mounted() {
    if (typeof window !== 'undefined') {
      this.windowWidth = window.innerWidth
      window.addEventListener('resize', this.updateWindowWidth)
    }
    // Carrega dados do usuário logado se estiver autenticado
    this.carregarDadosUsuarioLogado()
  },
  beforeUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateWindowWidth)
    }
  },
  methods: {
    async carregarPerfil() {
      this.carregando = true
      this.erro = false
      
      try {
        // Perfil de demonstração enquanto a API não existe
        if (this.username === 'demo' || this.username === 'exemplo') {
          await new Promise(resolve => setTimeout(resolve, 800)) // Simula delay da API
          this.perfilData = this.getDadosDemo()
          this.carregando = false
          return
        }

        const response = await ApiService.get(`/usuarios/ns/${this.username}`)
        const data = response.data || response
        this.perfilData = data.usuario || data
      } catch (error) {
        this.erro = true
        if (error.status === 404) {
          this.mensagemErro = `Perfil @${this.username} não encontrado`
        } else {
          this.mensagemErro = error.message || 'Erro ao carregar perfil'
        }
      } finally {
        this.carregando = false
      }
    },

    async carregarDadosUsuarioLogado() {
      // Verifica se está autenticado
      if (!this.isAuthenticated) return

      // Verifica se já tem os dados completos do usuário
      if (this.getUser && this.getUser.nome && this.getUser.email) return

      // Se só tem o ID, busca os dados completos
      const userId = this.getUser?.id
      if (!userId) {
        // Tenta pegar do localStorage diretamente
        const userStorage = localStorage.getItem('user-nexa')
        if (userStorage) {
          try {
            const parsed = JSON.parse(userStorage)
            if (parsed.id) {
              await this.buscarDadosUsuario(parsed.id)
            }
          } catch (e) {
            console.error('Erro ao parsear dados do usuário:', e)
          }
        }
        return
      }

      await this.buscarDadosUsuario(userId)
    },

    async buscarDadosUsuario(userId) {
      try {
        const response = await ApiService.get(`/Usuarios/${userId}`)
        let userData = response.data || response

        // Se for string JSON, faz parse
        if (typeof userData === 'string') {
          userData = JSON.parse(userData)
        }

        // Extrai dados do usuário se vier em um wrapper
        const user = userData.usuario || userData

        // Atualiza o Vuex com os dados completos
        this.$store.commit('auth/UPDATE_USER_DATA', user)
      } catch (error) {
        console.error('Erro ao buscar dados do usuário:', error)
        // Se der erro (token inválido, usuário não existe, etc), faz logout
        if (error.status === 401 || error.status === 403) {
          this.$store.dispatch('auth/logout')
        }
      }
    },

    getDadosDemo() {
      return {
        "id": 1,
        "usuario": "demo",
        "foto_perfil": null,
        "email": "demo@nexaskills.com",
        "nome": "Desenvolvedor Exemplo",
        "cep": "79011-060",
        "cidade": "Campo Grande",
        "uf": "MS",
        "ativo": true,
        "funcao": "Full-Stack Developer",
        "endereco": "Rua Exemplo",
        "numero": "123",
        "bairro": "Centro",
        "biografia": "Desenvolvedor full-stack com experiência em diversas tecnologias. Apaixonado por criar soluções inovadoras e escaláveis. Sempre buscando aprender novas tecnologias e compartilhar conhecimento com a comunidade.",
        "telefone": "(67) 99999-9999",
        "linkedin": "https://linkedin.com/in/desenvolvedor-exemplo",
        "descricao": "Perfil de demonstração",
        "git": "https://github.com/desenvolvedor-exemplo",
        "classes": [
          {
            "id": 1,
            "name": "Frontend",
            "classe_id": 1,
            "skills": [
              {
                "id": 1,
                "name": "Vue.js",
                "skill_id": 23,
                "nivel": "Mestre"
              },
              {
                "id": 2,
                "name": "React",
                "skill_id": 22,
                "nivel": "Profissional"
              },
              {
                "id": 3,
                "name": "HTML",
                "skill_id": 16,
                "nivel": "Professor"
              },
              {
                "id": 4,
                "name": "CSS",
                "skill_id": 17,
                "nivel": "Professor"
              },
              {
                "id": 5,
                "name": "Tailwind CSS",
                "skill_id": 20,
                "nivel": "Praticante"
              }
            ]
          },
          {
            "id": 2,
            "name": "Backend",
            "classe_id": 2,
            "skills": [
              {
                "id": 6,
                "name": "Node.js",
                "skill_id": 38,
                "nivel": "Profissional"
              },
              {
                "id": 7,
                "name": "Python",
                "skill_id": 4,
                "nivel": "Praticante"
              }
            ]
          },
          {
            "id": 3,
            "name": "Fullstack",
            "classe_id": 3,
            "skills": [
              {
                "id": 8,
                "name": "JavaScript",
                "skill_id": 1,
                "nivel": "Mestre"
              },
              {
                "id": 9,
                "name": "TypeScript",
                "skill_id": 2,
                "nivel": "Profissional"
              }
            ]
          }
        ],
        "top_habilidades": [
          {
            "id": 1,
            "name": "JavaScript",
            "skill_id": 1,
            "nivel": "Mestre",
            "posicao": 1,
            "cor": "Amarelo",
            "cor_hex": "#facc15",
            "estrelas": 5
          },
          {
            "id": 2,
            "name": "Vue.js",
            "skill_id": 23,
            "nivel": "Mestre",
            "posicao": 2,
            "cor": "Verde",
            "cor_hex": "#4ade80",
            "estrelas": 5
          },
          {
            "id": 3,
            "name": "HTML",
            "skill_id": 16,
            "nivel": "Professor",
            "posicao": 3,
            "cor": "Azul",
            "cor_hex": "#60a5fa",
            "estrelas": 4
          }
        ]
      }
    },
    
    getNivelStars(nivel) {
      const niveis = {
        'Iniciando': 0,
        'Aprendiz': 1,
        'Praticante': 2,
        'Profissional': 3,
        'Professor': 4,
        'Mestre': 5
      }
      return niveis[nivel] || 0    },

    voltarMeuPerfil() {
      this.$router.push('/espaco-nexa/perfil')    },
    
    buscarUsuario() {
      if (!this.usernameBusca || this.usernameBusca.trim() === '') {
        this.showWarningMessage('Digite um nome de usuário para buscar')
        return
      }
      
      // Remove @ se o usuário digitou
      let username = this.usernameBusca.trim()
      if (username.startsWith('@')) {
        username = username.substring(1)
      }
      
      // Navega para o perfil público do usuário buscado
      this.$router.push(`/ns/${username}`)
    },
    
    updateWindowWidth() {
      this.windowWidth = window.innerWidth
    },

    openLink(url) {
      if (!url) return
      
      if (url.startsWith('mailto:')) {
        // Para links de email, abre o Gmail web
        const email = url.replace('mailto:', '')
        const gmailUrl = `https://mail.google.com/mail/?view=cm&to=${encodeURIComponent(email)}`
        window.open(gmailUrl, '_blank', 'noopener,noreferrer')
      } else {
        // Para outros links (GitHub, LinkedIn), abre em nova aba
        window.open(url, '_blank', 'noopener,noreferrer')
      }
    },
    async copiarUsuario() {
      const usuario = this.usuarioApelido
      const textoCompleto = `@${usuario}`
      
      try {
        await navigator.clipboard.writeText(textoCompleto)
        this.showSuccessMessage('Usuário copiado para área de transferência!')
      } catch (error) {
        console.error('Erro ao copiar usuário:', error)
        this.showErrorMessage('Erro ao copiar usuário')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container-perfil-publico {
  width: 100%;
  min-height: 100vh;
  background-color: $corPreto;
  font-family: "Inter", sans-serif !important;

  .header-publico {
    width: 100%;
    height: 70px;
    background-color: $corFundoPadraoDashboard;
    border-bottom: 1px solid $borderColor;
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 100;

    .header-content {
      max-width: 1360px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 30px;
      box-sizing: border-box;

      .logo-section {
        display: flex;
        align-items: center;
        gap: 16px;

        .logo {
          height: 40px;
          width: auto;
          object-fit: contain;
          cursor: pointer;
          transition: opacity 0.2s ease;

          &:hover {
            opacity: 0.8;
          }
        }
      }

      .acoes {
        display: flex;
        gap: 12px;

        .btn-login {
          min-width: 100px;
        }
      }

      .user-avatar-container {
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: opacity 0.2s ease;

        &:hover {
          opacity: 0.8;
        }

        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid $corPrimary;
        }
      }
    }
  }

  .conteudo {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px;
    box-sizing: border-box;
  }

  .loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 70px);
    padding: 40px 20px;

    .spinner {
      width: 48px;
      height: 48px;
      border: 4px solid rgba(183, 255, 0, 0.2);
      border-top-color: #b7ff00;
      border-radius: 50%;
      animation: spin 1s linear infinite;
    }

    p {
      margin-top: 20px;
      color: #94a3b8;
      font-size: 16px;
    }
  }

  .erro {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 70px);
    text-align: center;
    padding: 40px 20px;

    svg {
      margin-bottom: 20px;
    }

    p {
      font-size: 18px;
      color: #f87171;
      margin-bottom: 30px;
    }
  }

  .conteudo {
    .busca-usuario {
      width: 100%;
      margin-bottom: 24px;
      padding: 20px;
      border: 1px solid $borderColor;
      border-radius: 8px;
      background-color: $corFundoPadraoDashboard;
      box-sizing: border-box;

      .busca-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .busca-label {
        display: flex;
        align-items: center;
        gap: 8px;
        color: $corValueInfoContato;
        font-size: 13px;
        font-weight: 500;

        svg {
          color: $corVerdeClaro;
          flex-shrink: 0;
        }
      }

      .busca-input-group {
        display: flex;
        gap: 10px;
        align-items: stretch;
      }

      .input-busca {
        flex: 1;
        min-width: 0;
        padding: 10px 14px;
        background-color: $corPreto;
        border: 1px solid $borderColor;
        border-radius: 6px;
        color: $corBranco;
        font-size: 14px;
        font-family: "Inter", sans-serif;
        transition: all 0.2s ease;

        &:focus {
          outline: none;
          border-color: $corVerdeClaro;
          box-shadow: 0 0 0 3px rgba(183, 255, 0, 0.1);
        }

        &::placeholder {
          color: #64748b;
        }
      }
    }

    .container-perfil {
      width: 100%;
      margin-top: 0;
      border: 1px solid $borderColor;
      border-radius: 8px;
      background-color: $corFundoPadraoDashboard;
      transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), box-shadow 0.25s cubic-bezier(0.4,0,0.2,1);

      &:hover {
        transform: scale(1.006);
        box-shadow: 0 5px 10px 0 #b7ff0033;
      }

      .header {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        padding: 0 25px;
        box-sizing: border-box;

        .info-desenvolvedor {
          display: flex;
          flex-direction: column;
          padding: 25px 0;

          .pessoa {
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 10px;

            .foto-perfil {
              width: 80px;
              height: 80px;
              min-width: 80px;
              min-height: 80px;
              border-radius: 50%;
              overflow: hidden;
              border: 2px solid $corVerdeClaro;
              box-sizing: border-box;
              position: relative;
              z-index: 0;
              aspect-ratio: 1/1;
              
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;
              }
            }

            .info {
              display: flex;
              flex-direction: column;
              flex: 1;
              min-width: 0;

              .nome {
                font-size: 20px;
                font-weight: bold;
                color: $corVerdeClaro;
                display: flex;
                align-items: center;
                gap: 15px;
                margin-bottom: 5px;
                width: 100%;
                min-width: 0;

                > span {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  flex-shrink: 1;
                }
              }

              .funcao, .localizacao, .usuario {
                font-size: 14px;
                color: $corValueInfoContato;
                display: flex;
                align-items: center;
                gap: 5px;
                margin-top: 5px;
              }

              .usuario {
                position: relative;
                
                .usuario-text {
                  margin-right: 5px;
                }

                .copiar-usuario {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  cursor: pointer;
                  color: $corValueInfoContato;
                  transition: all 0.2s;
                  padding: 4px;
                  border-radius: 4px;

                  &:hover {
                    color: $corVerdeClaro;
                    background: $corVerdeClaroHover;
                  }

                  &:active {
                    transform: scale(0.95);
                  }
                }
              }
            }
          }

          .descricao {
            font-size: 14px;
            color: $corValueInfoContato;
          }
        }

        .card-podium{
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 20px;
          max-width: 800px;
          width: 100%;
          margin: 0 auto;

          .top-3 {
            padding: 15px 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: $corPreto;
            border-radius: 8px;
            position: relative;
            border: 1px solid $borderColor;
            box-sizing: border-box;

            .trofeu {
              position: absolute;
              top: -8px;
              right: -7px;
              width: 28px;
              height: 28px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: $corFundoPadraoDashboard;
              border-radius: 100%;
              border: 2px solid $borderColor;
              box-sizing: border-box;
              z-index: 1;
            }

            &:hover{
              border-color: $corVerdeClaro;

              .trofeu {
                border-color: $corVerdeClaro;
              }
            }
      
            .habilidade {
              font-size: 14px;
              font-weight: 500;
              color: $corBranco;
              margin: 10px 0 6px 0;
            }
      
            .posicao {
              font-size: 12px;
              color: $corValueInfoContato;
            }
          }

          .mensagem-vazia {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px;
            text-align: center;
            color: $corValueInfoContato;
            width: 100%;

            svg {
              margin-bottom: 12px;
              opacity: 0.5;
            }

            p {
              font-size: 14px;
              font-weight: 500;
              margin: 0;
            }
          }
        }
      }

      .habilidades {
        margin-bottom: 25px;
        padding: 0 25px;
        box-sizing: border-box;

        .label-habilidades {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          color: $corVerdeClaro;
          font-size: 16px;
          font-weight: 600;

          svg {
            margin-right: 5px;
          }
        }

        .mensagem-vazia {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px 20px;
          text-align: center;
          color: $corValueInfoContato;
          border: 1px dashed $borderColor;
          border-radius: 8px;
          background: $corPreto;

          svg {
            margin-bottom: 12px;
            opacity: 0.5;
          }

          p {
            font-size: 14px;
            font-weight: 500;
            margin: 0;
          }
        }
      }

      .btn-acoes-social {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 20px;
        height: 80px;
        border-top: 1px solid $borderColor;
        padding: 0 25px;
        box-sizing: border-box;

        .btn-social-group {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-right: auto;
        }

        .btn-social {
          display: flex;
          align-items: center;
        }

        .btn-contato-wrapper {
          position: relative;
          display: inline-block;

          &:hover .tooltip-contato {
            visibility: visible;
            opacity: 1;
          }

          .tooltip-contato {
            visibility: hidden;
            opacity: 0;
            position: absolute;
            bottom: calc(100% + 8px);
            left: 50%;
            transform: translateX(-50%);
            background-color: $corPreto;
            color: $corBranco;
            padding: 8px 12px;
            border-radius: 6px;
            border: 1px solid $borderColor;
            font-size: 13px;
            white-space: nowrap;
            transition: opacity 0.2s, visibility 0.2s;
            z-index: 1000;
            pointer-events: none;

            &::after {
              content: '';
              position: absolute;
              top: 100%;
              left: 50%;
              transform: translateX(-50%);
              border: 5px solid transparent;
              border-top-color: $borderColor;
            }
          }
        }
      }
    }
  }
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style>

<style lang="scss">
.user-popover {
  background-color: $corFundoPadraoDashboard !important;
  border: 1px solid $borderColor !important;
  padding: 0 !important;
  font-family: "Inter", sans-serif !important;

  .user-popover-content {
    .user-info {
      padding: 20px;
      border-bottom: 1px solid $borderColor;

      .user-name {
        font-size: 16px;
        font-weight: 600;
        color: $corBranco;
        margin-bottom: 4px;
        word-break: break-word;
      }

      .user-email {
        font-size: 14px;
        color: $corValueInfoContato;
        word-break: break-word;
      }
    }

    .popover-actions {
      padding: 12px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .container-perfil-publico {
    .header-publico {
      .header-content {
        padding: 0 20px;

        .logo-section {
          .logo {
            height: 36px;
          }
        }

        .acoes {
          gap: 8px;
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .container-perfil-publico {
    .header-publico {
      height: 60px;

      .header-content {
        padding: 0 15px;

        .logo-section {
          .logo {
            height: 32px;
          }
        }
      }
    }

    .conteudo {
      padding: 20px 10px;
    }

    .loading,
    .erro {
      min-height: calc(100vh - 60px);
    }

    .conteudo {
      .busca-usuario {
        padding: 15px;
        margin-bottom: 15px;

        .busca-label {
          font-size: 12px;
        }

        .busca-input-group {
          flex-direction: column;
          gap: 8px;
        }

        .input-busca {
          padding: 10px 12px;
          font-size: 13px;
        }
      }

      .container-perfil {
        .header {
          .info-desenvolvedor {
            .pessoa {
              .info {
                .nome {
                  font-size: 16px;
                }
              }
            }
            .descricao {
              text-align: justify;
            }
          }
          .card-podium {
            gap: 10px;
          }
        }
      }
    }
  }
}

@media (max-width: 390px) {
  .container-perfil-publico {
    .conteudo {
      .container-perfil {
        .header {
          .card-podium {
            gap: 10px;
            .top-3 {
              padding: 15px 10px;
              min-width: 100px;

              .trofeu{
                top: -12px
              }
              .habilidade {
                font-size: 12px;
              }
              .posicao {
                font-size: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
